<div class="subheading">Let's get started. Tell us what you will be testing for:</div>
<div class="page-content">

  <app-persona-list
    [excludeTypes]="excludeTypes"
    (ngModelChange)="onSelectPersona($event)"
    [isGrid]="true"></app-persona-list>

</div>


